<h1 mat-dialog-title>{{ data?.document ? "Editar Documento" : "Novo Documento" }}</h1>

<form [formGroup]="documentForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nome do Documento</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="documentForm.get('name')?.hasError('required')"> Nome obrigatório </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Versão</mat-label>
      <input matInput formControlName="version" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Cargos associados</mat-label>
      <!-- <mat-select formControlName="cargos" multiple> -->
      <mat-select formControlName="cargoId">
        <mat-option *ngFor="let cargo of cargos" [value]="cargo.id">{{ cargo.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox formControlName="mandatory">Obrigatório</mat-checkbox>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Data de Validade</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="expiresAt" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <div class="upload-section">
      <label>Arquivo</label>
      <input type="file" (change)="onFileSelected($event)" />
      <small *ngIf="selectedFile">{{ selectedFile.name }}</small>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="documentForm.invalid">
      {{ data?.document ? "Salvar" : "Criar" }}
    </button>
  </mat-dialog-actions>
</form>
